import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { take, concatAll, map, toArray } from 'rxjs/operators';

import { BaseMiscDomainService } from '@common/domain/base-misc-domain.service';
import { mapSelectOptionBis } from '@common/operators';
import { SelectOption9 } from '@ui/components/form9/common';

import { ValuesMiscApiService } from '../api/values-misc-api.service';
import { Value } from './models';

@Injectable({
    providedIn: 'root'
})
export class ValuesMiscDomainService extends BaseMiscDomainService
{
    constructor (private valuesMiscApiService: ValuesMiscApiService)
    {
        super();
    }

    getPredefinterval (): Observable<SelectOption9[]>
    {
        const prefixKey: string = 'REPORT.PARAMETERS.ANALYSIS.PREDEFINTERVALS';

        return this.toSelectOption9WithPrefix(prefixKey, this.valuesMiscApiService.getPredefinterval());
    }

    getIntervaltype (): Observable<SelectOption9[]>
    {
        const prefixKey: string = 'REPORT.PARAMETERS.ANALYSIS';

        return this.toSelectOption9WithPrefix(prefixKey, this.valuesMiscApiService.getIntervaltype());
    }

    getPeriodicity (): Observable<SelectOption9[]>
    {
        const prefixKey: string = 'REPORT.PARAMETERS.SCHEDULE.PERIODICITY';

        return this.toSelectOption9WithPrefix(prefixKey, this.valuesMiscApiService.getPeriodicity());
    }

    getNumbersFormats (): Observable<SelectOption9[]>
    {
        const prefixKey: string = 'REPORT.PARAMETERS.DESCRIPTION.NUMBERSFORMATS';

        return this.valuesMiscApiService.getNumbersFormats()
            .pipe(
                concatAll(),
                map((value: Value) =>
                    new SelectOption9(value.value, `${prefixKey}.${value.key}`)
                ),
                toArray()
            );
    }

    private toSelectOption9WithPrefix (prefixKey: string, values: Observable<Value[]>): Observable<SelectOption9[]>
    {
        return values
            .pipe(
                take(1),
                mapSelectOptionBis(),
                concatAll(),
                map((so: SelectOption9) =>
                    new SelectOption9(so.value, `${prefixKey}.${so.label}`)
                ),
                toArray()
            );
    }
}
